import { useState, useEffect } from 'react';
import { BreakpointsContext } from '.';

import config from '../../config'
import { userAgentToMedia } from './user-agent-to-media';

export const BreakpointsProvider = ({ initialState, children }) => {
	const [breakpointState, setBreakpointState] = useState(initialState ?? {});

	const computeBreakpoints = () => {
		const breakpointInfo = userAgentToMedia(window?.navigator?.userAgent);
		// Define by window width:
		const isMobile = window?.innerWidth <= config.mobileBreakpoint;

		// Check additional navigator value:
		const isWindows = (navigator.platform.indexOf('Win') > -1);

		// Check additional window value:
		const isIos = breakpointInfo.isIos && !window.MSStream;

		setBreakpointState({
			...breakpointInfo,
			mobile: isMobile,
			desktop: !isMobile,
			isWindows,
			isIos,
		});

		if(isWindows) {
			document.documentElement.classList.add("platform-windows");
		}
	}

	useEffect(() => {
		computeBreakpoints();

		window.addEventListener('resize', computeBreakpoints);
	}, [])


	return <BreakpointsContext.Provider value={breakpointState}>
		{children}
	</BreakpointsContext.Provider>
}